import moment from 'moment'

export const AGE_LIMITS = {
  MIN: 1,
  MAX: 120,
} as const

export interface AgeValidationResult {
  isValid: boolean
  age: number
  errorMessage?: string
}

/**
 * Validate age from birth date string
 * @param birthDate - Date string in YYYY-MM-DD format
 * @param minAge - Minimum allowed age (default: 1)
 * @param maxAge - Maximum allowed age (default: 120)
 * @returns AgeValidationResult with isValid flag, calculated age, and optional error message
 */
export function validateAge(
  birthDate: string,
  minAge: number = AGE_LIMITS.MIN,
  maxAge: number = AGE_LIMITS.MAX
): AgeValidationResult {
  const now = moment()
  const dob = moment(birthDate)
  const age = moment.duration(now.diff(dob)).as('years')

  if (age < minAge) {
    return {
      isValid: false,
      age,
      errorMessage: `Invalid birth date: You must be at least ${minAge} year old.`,
    }
  }

  if (age > maxAge) {
    return {
      isValid: false,
      age,
      errorMessage: `Invalid birth date: Age cannot exceed ${maxAge} years.`,
    }
  }

  return { isValid: true, age }
}
